import * as React from 'react';
import {ViewProps} from './model';

export default (props: ViewProps) => {
  const {hide, gray, grayedColor, source, background, ...rest} = props;
  const SvgSource = source as React.FunctionComponent<React.SVGProps<SVGSVGElement> & {title?: string}>;
  const newProps = {
    ...rest,
    style: {
      ...props.style,
      filter: gray ? grayedColor ?? 'grayscale(1)' : undefined,
      opacity: hide ? 0 : 1,
    },
  };

  // ToDo: fix it
  // @ts-ignore
  return <SvgSource {...newProps} fill={background ?? 'none'} />;
};
